import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { businessInitialState } from "./states";
import axios from "axios";

const initialState = businessInitialState;

export const fetchBusinessAsync = createAsyncThunk(
  "business/Async",
  async (input, thunkApi) => {
    const { successCallback, errorCallback } = input;
    const { getState, rejectWithValue } = thunkApi;
    const { admin, business } = getState();

    const config = {
      headers: {
        authorization: `Bearer ${admin.accessToken}`
      }
    };

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_END_POINT}admin/getAllCompanies?index=${business.index}&limit=${business.limit}&search=${business.search}&activated=${business.filters.approved}&new_bizz=${business.filters.new_bizz}&reported=${business.filters.reported}`,
        config
      );
      if (successCallback && typeof successCallback === "function") {
        successCallback();
      }
      return {
        businesses: response.data.content,
        totalCount: response.data.totalBizz
      };
    } catch (error) {
      errorCallback(error);
      return rejectWithValue(error.response.data);
    }
  }
);

export const BusinessSlice = createSlice({
  name: "business",
  initialState,
  reducers: {
    verified: (state, action) => {
      const { id, newData } = action.payload;
      const index = state.value.findIndex((bizz) => bizz._id === id);
      if (index !== -1) {
        state.value[index] = {
          ...state.value[index],
          ...newData
        };
      }
    },
    setLimit: (state, action) => {
      state.limit = action.payload;
    },
    setIndex: (state, action) => {
      state.index = action.payload;
    },
    setApproved: (state, action) => {
      state.filters.approved = action.payload;
    },
    setNewBizz: (state, action) => {
      state.filters.new_bizz = action.payload;
    },
    setReported: (state, action) => {
      state.filters.reported = action.payload;
    },
    setSearchText: (state, action) => {
      state.search = action.payload;
    },
    clearFilter: (state) => {
      state.index = 0;
      state.filters.approved = null;
      state.filters.new_bizz = true;
      state.filters.reported = false;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchBusinessAsync.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchBusinessAsync.fulfilled, (state, action) => {
      state.isLoading = false;
      state.value = action.payload.businesses;
      state.totalCount = action.payload.totalCount;
    });
    builder.addCase(fetchBusinessAsync.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  }
});

export default BusinessSlice.reducer;
export const {
  verified,
  setIndex,
  setLimit,
  setApproved,
  setNewBizz,
  clearFilter,
  setReported,
  setSearchText
} = BusinessSlice.actions;
